import { useCallback, useState } from 'react';
import { transcribeVoice } from 'api/aiAssistant';
import { encodeWav } from './encodeWav';

export function useWhisper() {
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async (): Promise<void> => {
    // Remote service — nothing to preload.
  }, []);

  const transcribe = useCallback(async (pcm: Float32Array): Promise<string> => {
    try {
      const wav = encodeWav(pcm, 16000);
      return await transcribeVoice(wav);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      setError(message);
      throw err;
    }
  }, []);

  return {
    load,
    transcribe,
    isLoading: false,
    isReady: true,
    error,
  };
}
